var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['icon-number', {'disabled': _vm.disabled}],style:([_vm.bgStyle])},[_c('span',{staticClass:"text",style:([{'color': _vm.colorText}])},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"icon d-flex justify-content-center align-items-center"},[_c('font-awesome-icon',{attrs:{"icon":_vm.icon}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }